import {Link} from '@primer/react'
import {Fragment} from 'react'

import {containsSafeContent, isValidAndSafeUrl, prefixUrl, sanitizeInput} from '../../../utils/url'

const PUNCTUATION_REGEX = /^([(['"]*)(.*?)([.,:;!?\])"']*)$/

function cleanPunctuation(text: string): {cleanText: string; prefix: string; suffix: string} {
  const match = text.match(PUNCTUATION_REGEX)
  if (!match) {
    return {cleanText: text, prefix: '', suffix: ''}
  }

  const [_fullMatch, prefix = '', cleanText = '', suffix = ''] = match
  return {cleanText, prefix, suffix}
}

export function renderTextWithLinks(text: string): React.ReactElement | null {
  if (!text) {
    return null
  }

  const fragments = text.split(/(\s+)/)

  return (
    <>
      {fragments.map((fragment, index) => {
        const fragmentKey = `${fragment}-${index}`

        if (!fragment.trim()) {
          return <Fragment key={fragmentKey}>{fragment}</Fragment>
        }

        const {cleanText, prefix, suffix} = cleanPunctuation(fragment)

        if (!cleanText) {
          return <Fragment key={fragmentKey}>{fragment}</Fragment>
        }

        const sanitizedFragment = sanitizeInput(cleanText)
        const prefixedUrl = prefixUrl(sanitizedFragment)

        if (isValidAndSafeUrl(prefixedUrl) && containsSafeContent(prefixedUrl)) {
          return (
            <Fragment key={fragmentKey}>
              {prefix}
              <Link href={prefixedUrl} rel="noopener noreferrer">
                {sanitizedFragment}
              </Link>
              {suffix}
            </Fragment>
          )
        }

        return <Fragment key={fragmentKey}>{fragment}</Fragment>
      })}
    </>
  )
}

try{ PUNCTUATION_REGEX.displayName ||= 'PUNCTUATION_REGEX' } catch {}